import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import DashboardView from '../views/DashboardView.vue'
import AppHeader from '@/layout/AppHeader.vue'
import AppFooter from '@/layout/AppFooter.vue'
import XhHeader from '@/layout/XhHeader.vue'
import XhFooter from '../layout/XhFooter.vue'
import BlogLayout from '../layout/BlogLayout.vue'
import IndexView from '../views/IndexView.vue'
import LoginView from '../views/LoginView.vue'
import ShoppingBagView from '../views/ShoppingBagView.vue'
import SellView from '../views/SellView.vue'
import CheckoutView from '../views/CheckoutView.vue'
import PaymentView from '../views/PaymentView.vue'
import ResultView from '../views/ResultView.vue'
import WatchListView from '../views/WatchListView.vue'
import WatchPageView from '../views/WatchPageView.vue'
import UserView from '../views/UserView.vue'
import ResetPasswordView from '../views/ResetPasswordView.vue'
import UUPayHeader from '../layout/uupayHeader'
import UUPayHome from '../views/uupayHome'
import UUPayPage from '../views/uupayPage'
import UUPayApp from '../views/uupayApp'
import UUPayPos from '../views/uupayPos'
import UUPayConsole from '../views/uupayConsole'
import UUPayPrice from '../views/uupayPrice'
import UUPayBlog from '../views/uupayBlog'
import WonderBlog from '../views/WonderBlog'
import BlogDetail from '../views/BlogDetail'
import BlogDetail2 from '../views/BlogDetail2'
import UUPayMerchant from '../views/UUPayMerchant'
import MerchantCase from '../views/MerchantCase'
import MerchantDetail from '../views/MerchantDetail'

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        header: UUPayHeader,
        default: UUPayHome,
        footer: AppFooter,
      }
    },
    {
      path: '/uupay',
      name: 'uupay',
      components: {
        header: UUPayHeader,
        default: UUPayPage,
        footer: AppFooter,
      }
    },
    {
      path: '/app',
      name: 'app',
      components: {
        header: UUPayHeader,
        default: UUPayApp,
        footer: AppFooter,
      }
    },
    {
      path: '/pos',
      name: 'pos',
      components: {
        header: UUPayHeader,
        default: UUPayPos,
        footer: AppFooter,
      }
    },
    {
      path: '/console',
      name: 'console',
      components: {
        header: UUPayHeader,
        default: UUPayConsole,
        footer: AppFooter,
      }
    },
    {
      path: '/price',
      name: 'price',
      components: {
        header: UUPayHeader,
        default: UUPayPrice,
        footer: AppFooter,
      }
    },
    // {
    //   path: '/blog',
    //   name: 'blog',
    //   components: {
    //     header: UUPayHeader,
    //     default: UUPayBlog,
    //     footer: AppFooter,
    //   },
    // },
    // {
    //   path: '/wonderBlog',
    //   name: 'wonderBlog',
    //   components: {
    //     header: UUPayHeader,
    //     default: WonderBlog,
    //     footer: AppFooter,
    //   }
    // },
    // {
    //   path: '/blogs',
    //   components: {
    //     header: UUPayHeader,
    //     default: BlogLayout,  // 布局组件
    //     footer: AppFooter
    //   },
    //   children: [
    //     {
    //       path: '',  // 默认子路由，匹配 /blogs
    //       name: 'BlogList',
    //       component: UUPayBlog
    //     },
    //     {
    //       path: 'featured',  // 匹配 /blogs/featured
    //       name: 'FeaturedList',
    //       component: WonderBlog
    //     },
    //     {
    //       path: 'demo',  // 匹配 /blogs/:id
    //       name: 'BlogDetail2',
    //       component: BlogDetail2,
    //       props: true
    //     },
    //     {
    //       path: ':id',  // 匹配 /blogs/:id
    //       name: 'BlogDetail',
    //       component: BlogDetail,
    //       props: true
    //     }
        
    //   ]
    // },
    // {
    //   path: '/merchant',
    //   components: {
    //     header: UUPayHeader,
    //     default: BlogLayout,  // 布局组件
    //     footer: AppFooter
    //   },
    //   children: [
    //     {
    //       path: '',  // 默认子路由，匹配 /blogs
    //       name: 'case',
    //       component: UUPayMerchant
    //     },
    //     {
    //       path: 'featured',  // 匹配 /blogs/featured
    //       name: 'FeaturedList',
    //       component: MerchantCase
    //     },
    //     {
    //       path: ':id',  // 匹配 /blogs/:id
    //       name: 'MerchantDetail',
    //       component: MerchantDetail,
    //       props: true
    //     }
        
    //   ]
    // },
    {
      path: '/login',
      name: 'login',
      components: {
    	  header: XhHeader,
    	  default: LoginView,
    	  footer: XhFooter,
      }
    },
    {
      path: '/shoppingBag',
      name: 'shoppingBag',
      components: {
    	  header: XhHeader,
    	  default: ShoppingBagView,
    	  footer: XhFooter,
      }
    },
    {
    	path: '/sell',
    	name: 'sell',
    	components: {
    		header: XhHeader,
    		default: SellView,
    		footer: XhFooter,
    	}
    },
		{
			path: '/checkout',
			name: 'checkout',
			components: {
				header: '',
				default: CheckoutView,
				footer: XhFooter,
			}
		},
    {
    	path: '/payment',
    	name: 'payment',
    	components: {
    		header: '',
    		default: PaymentView,
    		footer: XhFooter,
    	}
    },
    {
    	path: '/result',
    	name: 'result',
    	components: {
    		header: '',
    		default: ResultView,
    		footer: XhFooter,
    	}
    },
    {
    	path: '/watchlist',
    	name: 'watchlist',
    	components: {
    		header: XhHeader,
    		default: WatchListView,
    		footer: XhFooter,
    	}
    },
    {
    	path: '/watchpage',
    	name: 'watchpage',
    	components: {
    		header: XhHeader,
    		default: WatchPageView,
    		footer: XhFooter,
    	}
    },
    {
    	path: '/user',
    	name: 'user',
    	components: {
    		header: XhHeader,
    		default: UserView,
    		footer: XhFooter,
    	}
    },
    {
      path: '/resetPassword',
      name: 'resetPassword',
      components: {
      	header: '',
      	default: ResetPasswordView,
      	footer: XhFooter,
      }
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      components: {
    			header: AppHeader,
    			// default: import(/* webpackChunkName: "about" */ '../views/AboutView.vue'),
    			default: AboutView,
    			footer: AppFooter,
    		}
    },
    {
    		path: '/dashboard',
    		name: 'dashboard',
    		component: DashboardView
    },

  ],
  scrollBehavior (to, from, savedPosition) { // 解决vue页面之间跳转，页面不是在顶部的问题
      return { x: 0, y: 0 }
  },
})



// WEBPACK FOOTER //
// ./src/router/index.js